/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './index.css';
import { isMobileOrTablet } from "../../components/Utils/index";
import parser from "html-react-parser";

function RevolutionaryLP({sunwestLink1, angelAiLink}) {
    const imgCDNURL = process.env.REACT_APP_CDN_URL + "eaimortgage/images/";
    const [imageSrc, setImageSrc] = useState("");

    useEffect(() => {
        // Determine which image to load based on device type
        const selectedImage = isMobileOrTablet() ? "revolutionarylp-mob.webp" : "revolutionarylp-desk.webp";
        setImageSrc(imgCDNURL + selectedImage);
    }, []);

    return (
        <section className="RevolutionaryLP-section">
            <Container>
                <Row className="RevolutionaryLP-row">
                    <Col lg={7} md={12} sm={12} className="RevolutionaryLP-column">
                        <h1 className="RevolutionaryLP-heading">Revolutionary Loan Programs Perfect for You</h1>
                        <p className="RevolutionaryLP-para">
                            EvolutionAi Mortgage, powered by {parser(sunwestLink1)} offers our customers not only competitive mortgage rates, but also a wide selection of mortgage products. We believe that everyone deserves the American dream and have loan programs available for credit scores as low as 500. Your loan officer and {parser(angelAiLink)} will help you decide which one is right for you and your family. No matter which loan program you choose, getting a TRU Approval<sup>®</sup> with EvolutionAi is an important step on your homebuying journey and will help you search for your dream home with confidence.
                        </p>
                    </Col>
                    <Col lg={5} md={12} sm={12} className="RevolutionaryLP-column-img">
                        <h1 className="RevolutionaryLP-heading-mob">Revolutionary Loan Programs Perfect for You</h1>
                        <img
                            src={imageSrc}
                            alt="Revolutionary Loan Programs Perfect for You"
                            className="RevolutionaryLP-img"
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default RevolutionaryLP;
